module.exports = __webpack_public_path__ + "static/media/taxi.f0fea688.jpg";